import styles from "./DisplayInput.module.css";

function SmallDisplayInput({
  labelText,
  name,
  value,
  type,
  placeholder,
  defaultValue,
  width,
  backgroundColor,
}) {
  return (
    <label className={styles.inputLabel} style={{ width: width }}>
      <p className={styles.inputLabelText}>{labelText}</p>
      <input
        name={name}
        value={value}
        type={type}
        placeholder={placeholder}
        className={styles.input}
        disabled={true}
        defaultValue={defaultValue || value}
        style={{ backgroundColor: backgroundColor || "#ffffff" }}
      />
    </label>
  );
}

export default SmallDisplayInput;
